import fileSaver from './../../../../../helpers/download.helper'
import { AxiosService } from './../../../../../services/axios.service'
import { pointsExtractConstants } from './points-extract.constants'
import { Creators as SiteCreators } from '../../../../../ducks/site/site'

const setSearchedUser = searchedUser => dispatch =>
	dispatch({
		type: pointsExtractConstants.SET_SEARCHED_USER,
		payload: searchedUser
	})

const addOptions = newOptions => dispatch => {
	dispatch({ type: pointsExtractConstants.ADD_OPTIONS, payload: newOptions })
}

const exportData = params => dispatch => {
	dispatch(SiteCreators.showLoading())

	AxiosService.get(`admin/relatorios/exportar-extrato-de-pontos`, {
		responseType: 'blob',
		params: params
	})
		.then(({ data }) => {
			dispatch(SiteCreators.hideLoading())
			downloadData(data)
		})
		.catch(() => dispatch(SiteCreators.hideLoading()))
}

const downloadData = async downloadData =>
	await fileSaver(downloadData, 'exportacao-de-extrato-de-pontos.csv')

export { setSearchedUser, addOptions, exportData }
